import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener
} from "@angular/core";
import { ModalService } from "../../utilities/modal/modal.service";
import { TwoFactorAuthService } from "./two-factor-auth.service";
import { ITwoFactorModel } from "./twoFactorModel";

@Component({
  selector: "[two-factor-auth-modal]",
  templateUrl: "./two-factor-auth-modal.component.html"
})
export class TwoFactorAuthModalComponent {
  @Input() modalId: string;
  @Input() contract: any;
  @Input() denyModalTitle: string;
  @Input() denyModalMsg: string;
  @Input() promptModalTitle: string;
  @Input() promptModalMsg: string;
  @Input() verifyCodeTitle: string;
  @Input() verifyCodeMsg: string;
  @ViewChild("errorDiv") errorDiv: ElementRef;
  payloadData: ITwoFactorModel;
  redirectUrl: string;
  hrtFlag: string;
  show2FaModal = false;

  constructor(
    private modalService: ModalService,
    private twoFactorAuthService: TwoFactorAuthService
  ) {}
  @HostListener("click", ["$event"])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (
      event &&
      event.target &&
      event.target.className.indexOf("two-factor-modal") > -1
    ) {
      // this.twoFactorAuthService.verifyCode = false;
      // this.twoFactorAuthService.loading = true;
      // this.twoFactorAuthService.error = [];
      // this.twoFactorAuthService.serviceFail = null;
      // this.show2FaModal = true;
      this.navigateToUrl();
    }
  }

  openModal() {
    this.modalService.open(this.modalId);
  }

  close(event: any) {
    this.payloadData = null;
    this.contract = null;
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.serviceFail = null;
    this.twoFactorAuthService.verifyCode = false;
    this.modalService.close(this.modalId);
    this.twoFactorAuthService.loading = true;
  }

  navigateToUrl() {
    this.twoFactorAuthService.verifyCode = false;
    this.twoFactorAuthService.loading = true;

    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.serviceFail = null;
    this.show2FaModal = true;
    this.twoFactorAuthService.getHrtAuth().subscribe(
      res => {
        if (res && /prompt|deny/i.test(res["hrtFlag"])) {
          this.openModal();
          this.hrtFlag = res["hrtFlag"].toLowerCase();
          this.twoFactorAuthService.loading = false;
        } else {
          this.twoFactorAuthService.loading = false;
          this.openInNewTab(this.contract.contractDetailLink);
        }
      },
      error => {
        this.openModal();
        this.twoFactorAuthService.checkingHRT = false;
        console.log('err hrt', error);
        //this.contract.contractDetailLink= null;
        this.twoFactorAuthService.loading = false;
        this.hrtFlag = null;
        this.twoFactorAuthService.serviceFail =
          "There was an error processing your request. Please try again later.";
      }
    );
  }
  openInNewTab(url) {
    var win = window.open(url, "_blank", "rel=noopener,noreferrer");
    //win.focus();
  }
}
